const date = new Date();
const year = date.getFullYear();
const isPOS = window.location.href.toLowerCase().includes("karlstechnology");
const isFFLBoss = window.location.href.toLowerCase().includes("fflboss");
const isTactical = window.location.href.toLowerCase().includes("tactical");

const APPCONFIG = {
	brand: (() => {
		let title = isTactical ? "Tactical POS" : 'FFL Boss POS';
		document.title = title;
		return title;
	})(),
	year,
	copyright: '2018',
	productLink: 'https://pos.karlstechnology.com',
	settings: {
		isDev: () => {
			if(isPOS || isFFLBoss){
				return window.location.hostname === 'dev.pos.karlstechnology.com' || window.location.hostname === 'beta.pos.karlstechnology.com';
			} else if (isTactical){
				return window.location.hostname === 'dev.tacticalpos.com' || window.location.hostname === 'beta.tacticalpos.com';
			}
		},
		apiURL: () => {
			if(isPOS) {
				return window.location.hostname === 'beta.pos.karlstechnology.com' ? "https://beta.api.pos.karlstechnology.com" : (
					window.location.hostname === 'dev.pos.karlstechnology.com' ?
						'https://dev.api.pos.karlstechnology.com' :
						'https://api.pos.karlstechnology.com')
					;
			} else if (isTactical){
				return window.location.hostname === 'beta.tacticalpos.com' ? "https://beta.api.pos.tacticalpos.com" : (
					window.location.hostname === 'dev.tacticalpos.com' ?
						'https://dev.api.pos.tacticalpos.com' :
						'https://api.pos.tacticalpos.com')
					;
			} else if (isFFLBoss){
				return window.location.hostname === 'beta.pos.fflboss.com' ? "https://beta.api.pos.fflboss.com" : (
					window.location.hostname === 'dev.pos.fflboss.com' ?
						'https://dev.api.pos.fflboss.com' :
						'https://api.pos.fflboss.com')
					;
			}
		},
		fflBossURL: () => {
			if(isPOS) {
				return window.location.hostname === 'beta.pos.karlstechnology.com' ?
					"https://beta.fflboss.com" :
					(window.location.hostname === 'pos.karlstechnology.com' ?
						'https://app.fflboss.com' :
						'https://dev.fflboss.com');
			} else if (isTactical){
				return window.location.hostname === 'beta.tacticalpos.com' ?
					"https://beta.fflboss.com" :
					(window.location.hostname === 'pos.tacticalpos.com' ?
						'https://app.fflboss.com' :
						'https://dev.fflboss.com');
			} else if (isFFLBoss){
				return window.location.hostname === 'beta.pos.fflboss.com' ?
					"https://beta.fflboss.com" :
					(window.location.hostname === 'pos.fflboss.com' ?
						'https://app.fflboss.com' :
						'https://dev.fflboss.com');
			}
		},
		apiVersion: 'v364'
	}
};

export default APPCONFIG;
